import React from 'react';
import styles from './SwapCalculator.module.scss';

interface TokenInputProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  loading?: boolean;
  editing?: boolean;
  disabled?: boolean;
  readOnly?: boolean;
  ariaLabel?: string;
  placeholder?: string;
  className?: string;
}

const TokenInput: React.FC<TokenInputProps> = ({
  value,
  onChange,
  onFocus,
  onBlur,
  loading = false,
  editing = false,
  disabled = false,
  readOnly = false,
  ariaLabel,
  placeholder,
  className = '',
}) => (
  <input
    className={`${styles.swapCalcInput}${editing ? ' ' + styles.editing : ''}${className ? ' ' + className : ''}`}
    type="number"
    min="0"
    value={loading ? '...' : value}
    aria-label={ariaLabel}
    onChange={onChange}
    onFocus={onFocus}
    onBlur={onBlur}
    readOnly={readOnly}
    disabled={disabled}
    placeholder={placeholder}
  />
);

export default TokenInput; 